import { createSelector } from 'reselect'

const getChildState = (state) => state.child

export const getFundingSummaryCalculator = createSelector([getChildState], (state) => (
  state.fundingSummaryCalculator?.data?.results || []
))
